import { FileType } from './../types/file-type';
import { ITextItemMediaModel, ITextItemMediaModelFile } from '../fi-text-item-helper/fi-text-item-media';

export function getVimeoUnavailableContainer(notAvailableHeader: string, notNotAvailableText: string): HTMLElement {
    const vimeoPlayerEl = document.createElement('div');
    vimeoPlayerEl.className =
        'fi-vimeo-player-not-available-container fi-text-item-media-item-size-original fi-text-item-media-item-alignment-center';
    vimeoPlayerEl.setAttribute('contenteditable', 'false');

    const icon = document.createElement('span');
    icon.className = 'fi-vimeo-player-not-available-icon fas fa-file-video BrandedColor';
    vimeoPlayerEl.appendChild(icon);

    const header = document.createElement('p');
    header.className = 'fi-vimeo-player-not-available-header';
    header.textContent = notAvailableHeader;
    vimeoPlayerEl.appendChild(header);

    const text = document.createElement('p');
    text.className = 'fi-vimeo-player-not-available-text';
    text.textContent = notNotAvailableText;
    vimeoPlayerEl.appendChild(text);
    return vimeoPlayerEl;
}

export function replaceVimeoNotAvailableLabelsInHtml(
    editorEl: HTMLElement,
    notAvailableHeaderLabel: string,
    notNotAvailableTextLabel: string,
): void {
    const notAvailableContainer = editorEl.querySelectorAll('.fi-vimeo-player-not-available-container');
    notAvailableContainer.forEach((container) => {
        const notAvailableHeader = container.querySelector('.fi-vimeo-player-not-available-header');
        if (notAvailableHeader) {
            notAvailableHeader.textContent = notAvailableHeaderLabel;
        }
        const notAvailableText = container.querySelector('.fi-vimeo-player-not-available-text');
        if (notAvailableText) {
            notAvailableText.textContent = notNotAvailableTextLabel;
        }
    });
}

export function getVimeoPreviewImgContainer(previewUrl: string): HTMLElement {
    const containerEl = document.createElement('div');
    containerEl.className =
        'video-preview-image-container fa playCircleIcon fi-text-item-media-item-alignment-center fi-text-item-media-item-size-original';
    containerEl.setAttribute('contenteditable', 'false');
    const imgElement = document.createElement('img');
    imgElement.className = 'video-preview-image';
    imgElement.src = previewUrl;
    imgElement.setAttribute('draggable', 'false');
    imgElement.setAttribute('fi-vimeo-video-preview-image', '');
    containerEl.appendChild(imgElement);
    return containerEl;
}

export function replaceVimeoNotAvailableContainerWithPreviewImage(
    textItemMediaModel: ITextItemMediaModel,
    notAvailableContainer: Element,
    previewImageSrc: string,
): void {
    const vimeoPreviewContainer = getVimeoPreviewImgContainer(previewImageSrc);
    vimeoPreviewContainer.setAttribute('ccm-text-item-media-model', JSON.stringify(textItemMediaModel));
    notAvailableContainer.classList.forEach((className) => {
        if (className !== 'fi-vimeo-player-not-available-container') {
            vimeoPreviewContainer.classList.add(className);
        }
    });
    notAvailableContainer.replaceWith(vimeoPreviewContainer);
}

export function getMediaEl(textItemMediaFile: ITextItemMediaModelFile, mediaUrl: string): HTMLElement | undefined {
    const mediaClass: string = 'fi-text-item-media-item-alignment-center fi-text-item-media-item-size-original';

    if (textItemMediaFile.FileType === FileType.Image) {
        const imageEl = document.createElement('img');
        imageEl.setAttribute('template-item-text-image', textItemMediaFile.FullName);
        imageEl.className = mediaClass;
        imageEl.src = mediaUrl;
        return imageEl;
    }
    if (textItemMediaFile.FileType === FileType.Movie) {
        const videoEl = document.createElement('video');
        videoEl.setAttribute('controls', 'true');
        videoEl.className = mediaClass;
        const sourceEl = document.createElement('source');
        sourceEl.src = mediaUrl;
        videoEl.appendChild(sourceEl);
        return videoEl;
    }
    return undefined;
}

export function getMediaAnchorEl(anchorSrc: string, innerText: string): HTMLElement {
    const anchorEl = document.createElement('a');
    anchorEl.href = anchorSrc;
    anchorEl.target = '_blank';
    anchorEl.textContent = innerText;
    return anchorEl;
}

export function getMediaWrapperAnchorEl(
    anchorSrc: string,
    innerContent: HTMLElement | string,
    isTargetBlank: boolean,
): HTMLElement {
    const anchorEl = document.createElement('a');
    anchorEl.href = anchorSrc;
    if (isTargetBlank) {
        anchorEl.target = '_blank';
    }
    if (innerContent instanceof HTMLElement) {
        anchorEl.appendChild(innerContent);
    } else {
        anchorEl.textContent = innerContent;
    }
    return anchorEl;
}
